import React from 'react';

export const Copy = ({ width = 20, height = 20, className, style }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0001 6.66667H8.33341C7.41294 6.66667 6.66675 7.41286 6.66675 8.33333V15C6.66675 15.9205 7.41294 16.6667 8.33341 16.6667H15.0001C15.9206 16.6667 16.6667 15.9205 16.6667 15V8.33333C16.6667 7.41286 15.9206 6.66667 15.0001 6.66667Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 6.66667V5C13.3333 4.55797 13.1577 4.13405 12.8451 3.82149C12.5325 3.50893 12.1086 3.33333 11.6666 3.33333H4.99992C4.55789 3.33333 4.13397 3.50893 3.82141 3.82149C3.50885 4.13405 3.33325 4.55797 3.33325 5V11.6667C3.33325 12.1087 3.50885 12.5326 3.82141 12.8452C4.13397 13.1577 4.55789 13.3333 4.99992 13.3333H6.66659"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
